var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.074 9.432a.769.769 0 0 0 .55-.228l4.54-4.54v2.519c0 .425.352.777.777.777a.783.783 0 0 0 .777-.777V2.788a.78.78 0 0 0-.062-.3.811.811 0 0 0-.425-.426.744.744 0 0 0-.3-.062H6.536a.783.783 0 0 0-.778.777c0 .425.353.778.778.778h2.518l-4.54 4.54c-.3.3-.3.798 0 1.098a.778.778 0 0 0 .56.239z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.96 11.702a.776.776 0 0 0-.985-.487 19.002 19.002 0 0 1-11.95 0 .78.78 0 0 0-.985.487.78.78 0 0 0 .487.985 20.464 20.464 0 0 0 6.468 1.046c2.197 0 4.384-.352 6.468-1.046a.782.782 0 0 0 .497-.985z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.97fef1055f3414b6668cb6ef168edffd.svg";
export { ForwardRef as ReactComponent };